import { useFlag } from '@/feature/feature-flags'
import { ObservatoryClusterer } from '@/feature/observatory'

export const useMapClusteringOptions = (): ObservatoryClusterer =>
  useFlag<ObservatoryClusterer>('mapClusteringOptions', {
    enabled: true,
  })
